module.exports = __webpack_public_path__ + "media/media/home/__img1-3ab3f72682e52416f4ea84ddec9f6426.png";